import angular from 'angular';

import resizeImage from './resizeImage';
import moeda from './moeda';

export default angular.module('filters', [])
    .filter(...resizeImage)
    .filter(...moeda)
    .name;



// WEBPACK FOOTER //
// ./src/app/filters/filters.js